/**
 * Marketing → auth entrance handoff (always cross-origin:
 * kontomatch.com → app.kontomatch.com, or local Astro → CRA).
 *
 * Only `?vt=white|green` works across origins. sessionStorage cannot —
 * it is not used here. Marketing must append the query param; this module
 * reads and strips it after consume.
 *
 * - white → auth-from-white (matches a white marketing cover)
 * - green → default auth-animated entrance (same as omitting vt)
 */
const AUTH_ENTRANCE_VARIANTS = new Set(["white", "green"]);

export type AuthEntranceTransition = "white" | "green" | "";

export function readAuthEntranceTransition(): AuthEntranceTransition {
  const raw = new URLSearchParams(window.location.search).get("vt");
  if (!raw) return "";
  const vt = raw.toLowerCase();
  if (!AUTH_ENTRANCE_VARIANTS.has(vt)) return "";
  return vt as "white" | "green";
}

/** Strip `?vt=` from the URL bar after the entrance variant has been applied. */
export function clearAuthEntranceTransition(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has("vt")) return;
  url.searchParams.delete("vt");
  const next = `${url.pathname}${url.search}${url.hash}`;
  window.history.replaceState({}, "", next);
}
